import { useCallback } from 'react';

import { useAuthFrom } from 'contexts/AuthProvider/useAuthFrom';
import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';

import { initiateMatrixSSORedirectCore } from './initiateMatrixSSORedirectCore';
import useNetworkErrorGuard from './useNetworkErrorGuard';

const useInitiateMatrixSSORedirect = () => {
  const { setLoginUrl } = useMatrixContext({ requireDefinedMatrixClient: false });
  const authFrom = useAuthFrom();
  const { runWithNetworkGuard } = useNetworkErrorGuard();

  return useCallback(
    (customMatrixUrl?: string | null) =>
      initiateMatrixSSORedirectCore(customMatrixUrl, { setLoginUrl, authFrom, runWithNetworkGuard }),
    [setLoginUrl, authFrom, runWithNetworkGuard]
  );
};

export default useInitiateMatrixSSORedirect;
